<div class="markant-step-container">
  <markant-step-indicator status="{{ userState }}" step="1">
    {{ 'organization.users.invite.steps.USER' | transloco }}
  </markant-step-indicator>
  <markant-step-indicator status="{{ roleState }}" step="2">
    {{ 'organization.users.invite.steps.ROLE' | transloco }}
  </markant-step-indicator>
  <markant-step-indicator status="{{ groupState }}" step="3">
    {{ 'organization.users.invite.steps.GROUP' | transloco }}
  </markant-step-indicator>
  <markant-step-indicator status="{{ cartridgeState }}" step="4">
    {{ 'organization.users.invite.steps.CARTRIDGE' | transloco }}
  </markant-step-indicator>
</div>
